module.exports = __webpack_public_path__ + "static/media/firstPageLastPic.7903871b.jpg";